import { useOnceEffect } from "@/utils/hooks";
import { generatePath, useNavigate, useParams } from "react-router";

interface Props {
  to: string;
}

export function Redirect(props: Readonly<Props>) {
  const navigate = useNavigate();
  const params = useParams();

  useOnceEffect(() => {
    navigate(generatePath(props.to, params), { replace: true });
  });

  return null;
}
